export default function() {
  return {
    landkreise: [],
  };
}
